import { computed, makeObservable, observable } from 'mobx';
import { nanoid } from 'nanoid';
import { ConsentStore } from './ConsentStore';
import Service from '../util/Service';
export class ConsentGroupStore {
    constructor(data, fromStorage = false) {
        var _a;
        this.consents = [];
        this.consentsOrigin = [];
        this.collapsibleOpen = false;
        makeObservable(this, {
            consents: observable,
            areAllConsentsDenied: computed,
            areAllConsentsAndFeaturesGranted: computed,
            collapsibleOpen: observable,
        });
        const { consents, ...restData } = data;
        Object.assign(this, restData);
        this.service = new Service();
        this.consents = consents.map((c) => new ConsentStore(c));
        this.$id = nanoid();
        this.name = (_a = this.name) !== null && _a !== void 0 ? _a : 'noname';
        if (this.required && !fromStorage) {
            this.consents.forEach((consent) => {
                consent.setGrantedWithFeatures(true);
            });
        }
        if (!fromStorage) {
            this.consentsOrigin = consents;
        }
    }
    oneClickToggle() {
        const currentState = this.areAllConsentsAndFeaturesGranted;
        this.consents.forEach((consent) => {
            consent.setGrantedWithFeatures(!currentState);
            consent.setModified(true);
        });
        this.service.fireEvent({
            name: 'consents/CHANGE',
            level: 'info',
            message: 'user changed a consent',
        });
    }
    denyAll() {
        if (!this.areAllConsentsDenied) {
            this.consents.forEach((consent) => {
                consent.setGrantedWithFeatures(false);
                consent.setModified(true);
            });
        }
        else {
            this.consents = this.consentsOrigin.map((c) => new ConsentStore(c));
        }
        this.service.fireEvent({
            name: 'consents/CHANGE',
            level: 'info',
            message: 'user changed a consent',
        });
    }
    get areAllConsentsDenied() {
        return !this.consents.find((c) => c.granted);
    }
    get areAllConsentsAndFeaturesGranted() {
        return !this.consents.find((c) => !c.granted || c.hasNotGrantedFeature);
    }
    get id() {
        return this.$id;
    }
    toJSON() {
        return {
            ...this,
            consents: this.consents.map((cs) => cs.toJSON()),
        };
    }
}
//# sourceMappingURL=ConsentGroupStore.js.map